import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto min-h-full" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import SimpleHeader from '@/components/tailwind/header/SimpleHeader.vue';
import SimpleFooter from '@/components/tailwind/footer/SimpleFooter.vue';
import PaidFeatureGate from '@/components/tailwind/PaidFeatureGate.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CRMLayout',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();
const contentVersion = ref(0);
const handleClose = () => router.push({ name: 'DashboardPage' });

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SimpleHeader, {
        "on-close": handleClose,
        pages: [
        { name: _unref(t)('sidemenu.navigation.crm.title'), href: _unref(router).resolve({ name: 'CRMDashboardPage' }).href, current: true },
      ]
      }, null, 8, ["pages"]),
      _createVNode(PaidFeatureGate, {
        feature: "crm",
        onAllowed: _cache[0] || (_cache[0] = ($event: any) => (contentVersion.value += 1))
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_RouterView, { key: contentVersion.value }))
        ]),
        _: 1
      })
    ]),
    _createVNode(SimpleFooter, { horizontal: true })
  ], 64))
}
}

})